import Table, { ColumnsType } from "antd/lib/table";
import { Moment } from "moment";
import { Link } from "react-router-dom";
import { mConstants } from "../../../../../helper/constants";
import helper from "../../../../../helper/helper";
import { IoPagination } from "../../../../../helper/pagination";
import { Assignment, TaskStatus } from "../../entity/task.model";

export const assignmentTableColumns: ColumnsType<Assignment> = [
  {
    title: "Д/д",
    dataIndex: "index",
    key: "index",
  },
  {
    title: "Үүсгэсэн ажилтан",
    dataIndex: "createdBy",
    key: "createdBy",
  },
  {
    title: "Үүсгэсэн огноо",
    dataIndex: "createdMoment",
    key: "createdMoment",
    render: (date: Moment) => date.format(mConstants.DATETIME_FORMAT),
  },
  {
    title: "Хариуцсан ажилтан",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Төлөв",
    dataIndex: "status",
    key: "status",
    render: (status: TaskStatus) => {
      return helper.getTaskStatus(status);
    },
  },
  {
    title: "Огноо",
    dataIndex: "assignedMoment",
    key: "assignedMoment",
    render: (date: Moment) => date.format(mConstants.DATE_FORMAT),
  },
  {
    title: "Гарчиг",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Үйлдлүүд",
    align: "center",
    key: "actions",
    dataIndex: "actions",
    render: (_: any, record: Assignment) => (
      <div className="list-icons">
        <div className="dropdown">
          <a href="#" className="list-icons-item" data-toggle="dropdown">
            <i className="icon-menu9"></i>
          </a>

          <div className="dropdown-menu dropdown-menu-right">
            <Link to={`/assignments/${record.uuid}`} className="dropdown-item">
              <i className="icon-pencil3"></i>
              Дэлгэрэнгүй
            </Link>
          </div>
        </div>
      </div>
    ),
  },
];

export interface AssignmentTableProps {
  pagination: IoPagination<Assignment>;
  onChange: (page: number, pageSize: number) => void;
}

function AssignmentTable(props: AssignmentTableProps) {
  return (
    <Table
      className="table table-responsive"
      columns={assignmentTableColumns}
      dataSource={props.pagination.content}
      pagination={{
        defaultCurrent: props.pagination.current,
        total: props.pagination.totalElements,
        onChange: props.onChange,
      }}
    />
  );
}

export default AssignmentTable;
